/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { templatesUpdate } from "../funcs/templatesUpdate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UpdatePromptTemplateResult } from "../models/components/updateprompttemplateresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateTemplateRequest,
  UpdateTemplateSecurity,
} from "../models/operations/updatetemplate.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateTemplateMutationVariables = {
  request: UpdateTemplateRequest;
  security?: UpdateTemplateSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateTemplateMutationData = UpdatePromptTemplateResult;

export type UpdateTemplateMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateTemplate templates
 *
 * @remarks
 * Update a prompt template.
 */
export function useUpdateTemplateMutation(
  options?: MutationHookOptions<
    UpdateTemplateMutationData,
    UpdateTemplateMutationError,
    UpdateTemplateMutationVariables
  >,
): UseMutationResult<
  UpdateTemplateMutationData,
  UpdateTemplateMutationError,
  UpdateTemplateMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateTemplateMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateTemplate(): MutationKey {
  return ["@gram/client", "templates", "update"];
}

export function buildUpdateTemplateMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateTemplateMutationVariables,
  ) => Promise<UpdateTemplateMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateTemplate(),
    mutationFn: function updateTemplateMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateTemplateMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(templatesUpdate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
